export function filterBySearchText<TItem>({
  getText,
  items,
  searchText,
}: {
  getText: (item: TItem) => string;
  items: readonly TItem[];
  searchText: string;
}) {
  const normalizedSearchText = searchText.trim().toLowerCase();

  if (!normalizedSearchText) {
    return [...items];
  }

  return items.filter((item) =>
    getText(item).toLowerCase().includes(normalizedSearchText),
  );
}
